function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
import isEmpty from 'ramda/src/isEmpty';
import isNil from 'ramda/src/isNil';
import pathOr from 'ramda/src/pathOr';
import pluck from 'ramda/src/pluck';
import propEq from 'ramda/src/propEq';
import clone from 'ramda/src/clone';
import Immutable from 'seamless-immutable';
import { createSelector } from 'reselect';
import uuid from 'uuid/v4';
import { CART_ITEM_TYPE, DEFAULT_CART_ITEM_VIEW_MODEL } from '../constants/products.wizard.constants';
var DEFAULT_PRODUCT_CART_VIEW_MODEL = {
  items: [],
  replaceItem: null,
  hasSubscriptionQuote: false,
  currencyCode: 'USD',
  // This gets overwritten below when there's a shopping cart available
  discountAmount: 0,
  discounts: '',
  subTotalAmount: 0,
  taxesCalculated: false,
  taxAmount: 0,
  taxInclusive: false,
  taxItems: [],
  totalAmount: 0,
  totalRemainingAmount: 0
};
var EMPTY_ARRAY = Immutable([]);
var _mapProductCartItemToViewModel = function mapProductCartItemToViewModel(items) {
  var productsMetadata = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var urlRegex = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
  var isRemovable = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : true;
  var isAddition = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;
  var isEditable = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : true;
  if (!items || !items.length) {
    return [];
  }
  return items.map(function (item, index) {
    var cartItemId = uuid();
    var pricingPlanTermsAndConditionsString = getPricingPlanTermsAndConditions(productsMetadata, item.ProductId, item.PricingPlanId);
    return Object.assign({}, DEFAULT_CART_ITEM_VIEW_MODEL, {
      availabilityDate: getPricingPlanAvailabilityDate(pathOr(null, ['Details', 'PricingPlan', 'AvailabilityStart'], item)),
      //verifies availability date is in the future
      childItems: item.ChildItems && item.ChildItems.length > 0 ? _mapProductCartItemToViewModel(item.ChildItems) : [],
      discountAmount: item.Details.GrossAmount - item.Details.TotalAmount,
      grossAmount: item.Details.GrossAmount,
      totalAmount: item.Details.TotalAmount,
      name: item.Details.Product.Name,
      pricingPlanName: item.Details.PricingPlan.Name,
      pricingPlanTermsAndConditions: pricingPlanTermsAndConditionsString,
      pricingPlanTermsAndConditionsIsUrl: pricingPlanTermsAndConditionsString && new RegExp(urlRegex).test(pricingPlanTermsAndConditionsString),
      pricingPlanId: item.PricingPlanId,
      productId: item.ProductId,
      instanceProperties: item.InstanceProperties,
      quantity: item.Quantity,
      id: cartItemId,
      index: index,
      isEditable: isEditable,
      isRemovable: isRemovable,
      itemType: isAddition ? CART_ITEM_TYPE.ADDITION : null
    });
  });
};
export var getBriName = function getBriName(cartItem, productsMetadata) {
  var product = productsMetadata[cartItem.ProductId];
  if (product) {
    var pricingPlan = product.PricingPlans.find(function (pricingPlan) {
      return pricingPlan.Id === cartItem.PricingPlanId;
    });
    if (pricingPlan.PricingPlanBillerRuleInstances) {
      var bris = [].concat(_toConsumableArray(pricingPlan.PricingPlanBillerRuleInstances.RecurringBillerRuleInstances), _toConsumableArray(pricingPlan.PricingPlanBillerRuleInstances.OneTimeBillerRuleInstances));
      return bris[0] && bris[0].Name || '';
    }
    return '';
  }
};
var getPathToAmount = function getPathToAmount(bri, path) {
  return pathOr(0, ['BillerRuleInstanceCharges', 0, path], bri);
};
var getSummedAmounts = function getSummedAmounts(dbssBRIs, amountPath) {
  // TODO - Temporary solution. We should not be doing front end math here
  return dbssBRIs.reduce(function (prev, cur) {
    // if bri does not contain 'NonDiscountChargeAmount' then use 'ChargeAmount' property
    var pathToAmount = amountPath === 'NonDiscountChargeAmount' && !getPathToAmount(cur, amountPath) ? getPathToAmount(cur, 'ChargeAmount') : getPathToAmount(cur, amountPath);
    return prev + pathToAmount;
  }, 0);
};
var _mapServiceFeatureProductCartItemToViewModel = function mapServiceFeatureProductCartItemToViewModel(items) {
  var productsMetadata = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var urlRegex = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
  var isRemovable = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : true;
  var isAddition = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;
  var isEditable = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : true;
  var submitChangeOfServiceRequest = arguments.length > 6 ? arguments[6] : undefined;
  var checkRemoveItems = arguments.length > 7 && arguments[7] !== undefined ? arguments[7] : false;
  var newItems = items && items.asMutable ? items.asMutable({
    deep: true
  }) : items;
  if (!newItems || !newItems.length) {
    return [];
  }
  return newItems.map(function (item, index) {
    var cartItemId = uuid();
    var pricingPlanTermsAndConditionsString = getPricingPlanTermsAndConditions(productsMetadata, item.ProductId, item.PricingPlanId);
    var isAddItem = null;
    var indexOfAddItem = submitChangeOfServiceRequest ? submitChangeOfServiceRequest.AddItems.findIndex(function (quantity) {
      return quantity.PricingPlanId === item.PricingPlanId && quantity.ProductId === item.ProductId;
    }) : -1;
    if (indexOfAddItem > -1) {
      isAddItem = submitChangeOfServiceRequest.AddItems[indexOfAddItem];
      submitChangeOfServiceRequest.AddItems.splice(indexOfAddItem, 1);
    }
    var isRemoveItem = checkRemoveItems && submitChangeOfServiceRequest ? submitChangeOfServiceRequest.RemoveItems.find(function (quantity) {
      if (quantity.PricingPlanId === item.PricingPlanId && quantity.ProductId === item.ProductId) {
        return quantity.PricingPlanId === item.PricingPlanId && quantity.ProductId === item.ProductId;
      }
      ;
    }) : null;
    var dbssBRIs = item.Details.PricingPlan && item.Details.PricingPlan.PricingPlanBillerRuleInstances ? [].concat(_toConsumableArray(item.Details.PricingPlan.PricingPlanBillerRuleInstances.RecurringBillerRuleInstances), _toConsumableArray(item.Details.PricingPlan.PricingPlanBillerRuleInstances.OneTimeBillerRuleInstances)) : [];
    var billerRuleAmount = item.Details.PricingPlan && item.Details.PricingPlan.BillerRuleInstanceThumbnails ? item.Details.PricingPlan.BillerRuleInstanceThumbnails.find(function (billerRule) {
      return billerRule.Amount;
    }) : null;
    var newObject = {
      availabilityDate: getPricingPlanAvailabilityDate(pathOr(null, ['Details', 'PricingPlan', 'AvailabilityStart'], item)),
      //verifies availability date is in the future
      childItems: item.ChildItems && item.ChildItems.length > 0 ? _mapServiceFeatureProductCartItemToViewModel(item.ChildItems) : [],
      discountAmount: getSummedAmounts(dbssBRIs, 'DiscountActualAmount') * item.Quantity,
      grossAmount: getSummedAmounts(dbssBRIs, 'NonDiscountChargeAmount') * item.Quantity,
      totalAmount: item.AdHocOverrideDetails && item.AdHocOverrideDetails.Amount !== undefined ? item.AdHocOverrideDetails.Amount : billerRuleAmount ? billerRuleAmount.Amount : getSummedAmounts(dbssBRIs, 'ChargeAmount') * item.Quantity,
      name: item.Details.Product.Name,
      pricingPlanName: item.Details.PricingPlan.Name,
      pricingPlanTermsAndConditions: pricingPlanTermsAndConditionsString,
      pricingPlanTermsAndConditionsIsUrl: pricingPlanTermsAndConditionsString && new RegExp(urlRegex).test(pricingPlanTermsAndConditionsString),
      pricingPlanId: item.PricingPlanId,
      adHocBrcName: item.AdHocOverrideDetails ? item.AdHocOverrideDetails.InvoiceText || getBriName(item, productsMetadata) : getBriName(item, productsMetadata),
      classification: item.Details.Product.ProductClassification,
      productId: item.ProductId,
      instanceProperties: item.InstanceProperties,
      quantity: item.Quantity,
      id: cartItemId,
      index: index,
      isEditable: isEditable,
      isRemovable: isRemovable
    };
    if (isRemoveItem) {
      var removeQuantity = isRemoveItem.Quantity && !Number.isNaN(isRemoveItem.Quantity) ? isRemoveItem.Quantity : 0;
      newObject.customQuantity = isRemoveItem.existingQuantity - removeQuantity;
    }
    if (isAddItem) {
      newObject.customQuantity = isAddItem.Quantity - isAddItem.existingQuantity;
    }
    newObject.itemType = null;
    if (isAddition || isAddItem) {
      newObject.itemType = CART_ITEM_TYPE.ADDITION;
    }
    if (isRemoveItem) {
      newObject.itemType = CART_ITEM_TYPE.REMOVAL;
    }
    return Object.assign({}, DEFAULT_CART_ITEM_VIEW_MODEL, newObject);
  });
};
var getCartItemForModifyItem = function getCartItemForModifyItem(modifyItem) {
  if (isNil(modifyItem) || isEmpty(modifyItem)) {
    return null;
  }
  var modifyData = Object.assign({}, {
    ProductId: modifyItem.Product.Id,
    PricingPlanId: modifyItem.PricingPlan.Id,
    Details: modifyItem,
    ChildItems: modifyItem.Children.map(function (itemChild) {
      return {
        ProductId: itemChild.Product.Id,
        PricingPlanId: itemChild.PricingPlan.Id,
        Details: itemChild,
        InstanceProperties: itemChild.InstanceProperties,
        Quantity: itemChild.Quantity || 1
      };
    }),
    InstanceProperties: modifyItem.InstanceProperties,
    Quantity: modifyItem.Quantity || 1
  });
  var arr = _mapProductCartItemToViewModel([modifyData], {}, null, false);
  return arr && arr.length ? arr[0] : {};
};
export var getPricingPlanAvailabilityDate = function getPricingPlanAvailabilityDate(availabilityDate) {
  return new Date(availabilityDate) > new Date() ? availabilityDate : null;
};
var getPricingPlanTermsAndConditions = function getPricingPlanTermsAndConditions(shoppingCartProductsMetadata, productId, pricingPlanId) {
  if (!shoppingCartProductsMetadata[productId]) {
    return null;
  }
  var selectedPricingPlan = shoppingCartProductsMetadata[productId].PricingPlans.find(propEq(pricingPlanId, 'Id'));
  return pathOr(null, ['TermsAndConditions'], selectedPricingPlan);
};
var mapPascalToCamelCaseKeys = function mapPascalToCamelCaseKeys(taxItems) {
  return taxItems.map(function (taxItem) {
    return Object.keys(taxItem).reduce(function (accum, key) {
      accum[key.toLowerCase()] = taxItem[key];
      return accum;
    }, {});
  });
};
var mapDiscountsToViewModel = function mapDiscountsToViewModel(discountsStringList, discretionaryDiscounts) {
  var discounts = discountsStringList !== '' ? discountsStringList.split(/,\s?/) : [];
  return discretionaryDiscounts.length ? discounts.concat(pluck('Name', discretionaryDiscounts)) : [];
};
var mapShippingItems = function mapShippingItems(shippingAmount, selectedShippingMethodId, shippingMethods) {
  if (isNil(selectedShippingMethodId) || isNil(shippingMethods)) {
    return EMPTY_ARRAY;
  }
  selectedShippingMethodId = Number(selectedShippingMethodId);
  if (isNaN(selectedShippingMethodId)) {
    return EMPTY_ARRAY;
  }
  var selectedMethod = shippingMethods.find(function (shippingMethod) {
    return shippingMethod.Id === selectedShippingMethodId;
  });
  if (isNil(selectedMethod)) {
    return EMPTY_ARRAY;
  }
  return [{
    amount: shippingAmount,
    description: selectedMethod.Name
  }];
};
var cartHasSubscriptionItem = function cartHasSubscriptionItem(cart) {
  return !cart.Items ? false : cart.Items.some(function (item) {
    return item.Details.PricingPlan.Subscription;
  });
};
var cartHasShippedItem = function cartHasShippedItem(cart) {
  return !cart.Items ? false : cart.Items.some(function (item) {
    return item.Details.PricingPlan.Shipped;
  });
};
export var CartTab = function CartTab(inputSelectors) {
  return createSelector(inputSelectors, function (shoppingCartMetadata, shoppingCart, orderQuote, selectedShippingMethodId, modifyCartItem, replaceCartItem, discretionaryDiscounts, isReplacing, isModifying, isRestoring, urlRegex) {
    if (shoppingCart.Items && shoppingCart.Items.length || modifyCartItem && !isEmpty(modifyCartItem)) {
      var cartItemsAreRemovableInFlow = !isModifying && !isReplacing && !isRestoring;
      if (orderQuote && orderQuote.quoteIsValid) {
        return {
          currencyCode: orderQuote.currency || shoppingCart.Currency || DEFAULT_PRODUCT_CART_VIEW_MODEL.currencyCode,
          brandableCurrencyName: orderQuote.brandableCurrencyName || shoppingCart.BrandableCurrencyName,
          discountAmount: orderQuote.discountAmount,
          discounts: mapDiscountsToViewModel(orderQuote.appliedCoupons || shoppingCart.AppliedCoupons || DEFAULT_PRODUCT_CART_VIEW_MODEL.discounts, discretionaryDiscounts),
          hasSubscriptionQuote: cartHasSubscriptionItem(shoppingCart),
          items: _mapProductCartItemToViewModel(shoppingCart.Items, shoppingCartMetadata, urlRegex, cartItemsAreRemovableInFlow, isReplacing, !isRestoring),
          modifyItem: isModifying ? getCartItemForModifyItem(modifyCartItem) : null,
          replaceItem: replaceCartItem,
          shippingAmount: orderQuote.shippingAmount,
          shippingItems: mapShippingItems(orderQuote.shippingAmount, selectedShippingMethodId, orderQuote.ShippingMethods),
          shippingRequired: shoppingCart.ShippingRequired || cartHasShippedItem(shoppingCart),
          subTotalAmount: orderQuote.subTotal,
          taxesCalculated: true,
          taxAmount: orderQuote.taxAmount,
          taxInclusive: orderQuote.taxInclusive,
          taxItems: mapPascalToCamelCaseKeys(orderQuote.taxItems || DEFAULT_PRODUCT_CART_VIEW_MODEL.taxItems),
          totalAmount: orderQuote.totalAmount,
          totalRemainingAmount: orderQuote.totalRemainingAmount || 0
        };
      } else {
        return {
          currencyCode: shoppingCart.Currency || DEFAULT_PRODUCT_CART_VIEW_MODEL.currencyCode,
          brandableCurrencyName: shoppingCart.BrandableCurrencyName,
          discountAmount: shoppingCart.DiscountAmount,
          discounts: mapDiscountsToViewModel(shoppingCart.AppliedCoupons || DEFAULT_PRODUCT_CART_VIEW_MODEL.discounts, discretionaryDiscounts),
          hasSubscriptionQuote: false,
          items: _mapProductCartItemToViewModel(shoppingCart.Items, shoppingCartMetadata, urlRegex, cartItemsAreRemovableInFlow, isReplacing, !isRestoring),
          modifyItem: isModifying ? getCartItemForModifyItem(modifyCartItem) : null,
          replaceItem: replaceCartItem,
          shippingAmount: 0,
          shippingItems: [],
          shippingRequired: shoppingCart.ShippingRequired,
          subTotalAmount: shoppingCart.GrossAmount,
          taxesCalculated: false,
          taxAmount: 0,
          taxInclusive: false,
          taxItems: [],
          totalAmount: shoppingCart.TotalAmount,
          totalRemainingAmount: orderQuote.totalRemainingAmount || 0
        };
      }
    } else if (replaceCartItem) {
      return Object.assign({}, DEFAULT_PRODUCT_CART_VIEW_MODEL, {
        replaceItem: replaceCartItem
      });
    } else {
      return DEFAULT_PRODUCT_CART_VIEW_MODEL;
    }
  });
};
export var QuoteTab = function QuoteTab(inputSelectors) {
  return createSelector(inputSelectors, function (shoppingCartMetadata, shoppingCart, orderQuote, selectedShippingMethodId, modifyCartItem, replaceCartItem, discretionaryDiscounts, isReplacing, isModifying, isRestoring, urlRegex, submitChangeOfServiceForServiceFeatureRequest) {
    if (shoppingCart.Items && shoppingCart.Items.length || submitChangeOfServiceForServiceFeatureRequest.RemoveItems && submitChangeOfServiceForServiceFeatureRequest.RemoveItems.length) {
      var cartItemsAreRemovableInFlow = !isModifying && !isReplacing && !isRestoring;
      var uniqueRemoveItemsHash = {};
      if (orderQuote && orderQuote.quoteIsValid) {
        var returnObj = {
          currencyCode: orderQuote.currency || shoppingCart.Currency || DEFAULT_PRODUCT_CART_VIEW_MODEL.currencyCode,
          brandableCurrencyName: orderQuote.brandableCurrencyName || shoppingCart.BrandableCurrencyName,
          discountAmount: orderQuote.discountAmount,
          discounts: mapDiscountsToViewModel(orderQuote.appliedCoupons || shoppingCart.AppliedCoupons || DEFAULT_PRODUCT_CART_VIEW_MODEL.discounts, discretionaryDiscounts),
          hasSubscriptionQuote: cartHasSubscriptionItem(shoppingCart),
          items: _mapServiceFeatureProductCartItemToViewModel(shoppingCart.Items, shoppingCartMetadata, urlRegex, cartItemsAreRemovableInFlow, isReplacing, !isRestoring, clone(submitChangeOfServiceForServiceFeatureRequest)),
          modifyItem: isModifying ? getCartItemForModifyItem(modifyCartItem) : null,
          orderQuoteTotals: orderQuote.orderQuoteTotals,
          replaceItem: replaceCartItem,
          shippingAmount: orderQuote.shippingAmount,
          shippingItems: mapShippingItems(orderQuote.shippingAmount, selectedShippingMethodId, orderQuote.ShippingMethods),
          shippingRequired: shoppingCart.ShippingRequired || cartHasShippedItem(shoppingCart),
          subTotalAmount: orderQuote.subTotal,
          taxesCalculated: true,
          taxAmount: orderQuote.taxAmount,
          taxInclusive: orderQuote.taxInclusive,
          taxItems: mapPascalToCamelCaseKeys(orderQuote.taxItems || DEFAULT_PRODUCT_CART_VIEW_MODEL.taxItems),
          totalAmount: orderQuote.totalAmount,
          totalRemainingAmount: orderQuote.totalRemainingAmount || 0
        };
        var _uniqueRemoveItemsHash = {};
        if (submitChangeOfServiceForServiceFeatureRequest.RemoveItems && submitChangeOfServiceForServiceFeatureRequest.RemoveItems.length) {
          submitChangeOfServiceForServiceFeatureRequest.RemoveItems.forEach(function (item) {
            if (_uniqueRemoveItemsHash[item.PricingPlanId]) {
              _uniqueRemoveItemsHash[item.PricingPlanId].Quantity += 1;
            } else {
              _uniqueRemoveItemsHash[item.PricingPlanId] = clone(item);
            }
          });
        }
        var uniqueRemoveItems = [];
        for (var _i = 0, _Object$entries = Object.entries(_uniqueRemoveItemsHash); _i < _Object$entries.length; _i++) {
          var _Object$entries$_i = _slicedToArray(_Object$entries[_i], 2),
            item = _Object$entries$_i[1];
          uniqueRemoveItems.push(item);
        }
        uniqueRemoveItems.forEach(function (removeItem) {
          returnObj.items = returnObj.items.concat(_mapServiceFeatureProductCartItemToViewModel([removeItem], shoppingCartMetadata, urlRegex, cartItemsAreRemovableInFlow, isReplacing, !isRestoring, clone(submitChangeOfServiceForServiceFeatureRequest), true));
        });
        return returnObj;
      } else {
        var _returnObj = {
          currencyCode: shoppingCart.Currency || DEFAULT_PRODUCT_CART_VIEW_MODEL.currencyCode,
          brandableCurrencyName: shoppingCart.BrandableCurrencyName,
          discountAmount: shoppingCart.DiscountAmount,
          discounts: mapDiscountsToViewModel(shoppingCart.AppliedCoupons || DEFAULT_PRODUCT_CART_VIEW_MODEL.discounts, discretionaryDiscounts),
          hasSubscriptionQuote: false,
          items: _mapServiceFeatureProductCartItemToViewModel(shoppingCart.Items, shoppingCartMetadata, urlRegex, cartItemsAreRemovableInFlow, isReplacing, !isRestoring, clone(submitChangeOfServiceForServiceFeatureRequest)),
          modifyItem: isModifying ? getCartItemForModifyItem(modifyCartItem) : null,
          orderQuoteTotals: orderQuote.orderQuoteTotals,
          replaceItem: replaceCartItem,
          shippingAmount: 0,
          shippingItems: [],
          shippingRequired: shoppingCart.ShippingRequired,
          subTotalAmount: shoppingCart.GrossAmount,
          taxesCalculated: false,
          taxAmount: 0,
          taxInclusive: false,
          taxItems: [],
          totalAmount: shoppingCart.TotalAmount,
          totalRemainingAmount: orderQuote.totalRemainingAmount || 0
        };
        if (submitChangeOfServiceForServiceFeatureRequest.RemoveItems && submitChangeOfServiceForServiceFeatureRequest.RemoveItems.length) {
          submitChangeOfServiceForServiceFeatureRequest.RemoveItems.forEach(function (item) {
            if (uniqueRemoveItemsHash[item.PricingPlanId]) {
              uniqueRemoveItemsHash[item.PricingPlanId].Quantity += 1;
            } else {
              uniqueRemoveItemsHash[item.PricingPlanId] = clone(item);
            }
          });
        }
        var _uniqueRemoveItems = [];
        for (var _i2 = 0, _Object$entries2 = Object.entries(uniqueRemoveItemsHash); _i2 < _Object$entries2.length; _i2++) {
          var _Object$entries2$_i = _slicedToArray(_Object$entries2[_i2], 2),
            _item = _Object$entries2$_i[1];
          _uniqueRemoveItems.push(_item);
        }
        _uniqueRemoveItems.forEach(function (removeItem) {
          _returnObj.items = _returnObj.items.concat(_mapServiceFeatureProductCartItemToViewModel([removeItem], shoppingCartMetadata, urlRegex, cartItemsAreRemovableInFlow, isReplacing, !isRestoring, clone(submitChangeOfServiceForServiceFeatureRequest), true));
        });
        return _returnObj;
      }
    } else {
      return DEFAULT_PRODUCT_CART_VIEW_MODEL;
    }
  });
};